(() => {
  if (customElements.get('pradipatva-offer-ticker')) return;
  customElements.define('pradipatva-offer-ticker', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const button = this.querySelector('button');
      if (!button) return;
      this.controller = new AbortController();
      this.classList.add('is-ready');
      button.hidden = false;
      button.addEventListener('click', () => {
        const paused = this.classList.toggle('is-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.resumeLabel : button.dataset.pauseLabel);
        button.firstElementChild.textContent = paused ? '▷' : 'Ⅱ';
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
})();
